export default "__VITE_ASSET__674e5424__"